import { render } from "./partnerTr2.vue?vue&type=template&id=564cef2e&scoped=true"
import script from "./partnerTr2.vue?vue&type=script&lang=js"
export * from "./partnerTr2.vue?vue&type=script&lang=js"

import "./partnerTr2.vue?vue&type=style&index=0&id=564cef2e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\USER\\Desktop\\중요\\tcd-cube_opr\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-564cef2e"]])

export default __exports__